// Team page
// - Validates `:teamId` and `?edit` locally
// - If `teamId === "new"` without ?edit => go back one step (same as old loader -> needGoBack)
// - Shows Spinner while Firebase data is loading
// - Renders <h1> error instead of using errorElement/loader

import { useEffect } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import TeamCard from '../components/TeamCard';
import Spinner from '../components/Spinner';
import { useTeam } from '../utils/hooks';

export default function PageTeam() {
  const { teamId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { entity: team, isResolved } = useTeam(teamId);

  // Handle "create new" route: /teams/new
  useEffect(() => {
    // If user navigates to "new" without ?edit
    if (teamId === 'new') {
      const editParam = searchParams.get('edit');
      if (!editParam) navigate(-1, { replace: true });
    }
  }, [teamId, searchParams, navigate]);

  // Case: creating a new team with ?edit present
  if (teamId === 'new') {
    const editParam = searchParams.get('edit');

    // If redirect just triggered (no ?edit), keep UI calm with a spinner
    if (!editParam) {
      return (
        <Layout screenSized className='page-team'>
          <Spinner show />
        </Layout>
      );
    }

    // Render creation mode; pass minimal shape if your card expects an object
    return (
      <Layout className='page-team' trail>
        <TeamCard team={{ id: 'new' }} />
      </Layout>
    );
  }

  // Spinner only while the record could still show up
  if (!team && !isResolved) {
    return (
      <Layout screenSized className='page-team'>
        <Spinner show />
      </Layout>
    );
  }

  // Not found => plain H1 error
  if (!team) {
    return (
      <Layout screenSized className='page-team'>
        <h1>{`Error: no route matches url "/teams/${teamId}"`}</h1>
      </Layout>
    );
  }

  // Happy path
  return (
    <Layout className='page-team' trail>
      <TeamCard team={team} />
    </Layout>
  );
}
